export const STORES = [
  { key: "amazon", label: "Amazon", domain: "amazon.com", hint: "https://www.amazon.com/wedding/…" },
  { key: "target", label: "Target", domain: "target.com", hint: "https://www.target.com/gift-registry/…" },
  { key: "walmart", label: "Walmart", domain: "walmart.com", hint: "https://www.walmart.com/registry/…" },
  { key: "crateandbarrel", label: "Crate & Barrel", domain: "crateandbarrel.com", hint: "https://www.crateandbarrel.com/gift-registry/…" },
  { key: "williams-sonoma", label: "Williams Sonoma", domain: "williams-sonoma.com", hint: "https://www.williams-sonoma.com/registry/…" },
  { key: "potterybarn", label: "Pottery Barn", domain: "potterybarn.com", hint: "https://www.potterybarn.com/registry/…" },
  { key: "bedbathandbeyond", label: "Bed Bath & Beyond", domain: "bedbathandbeyond.com", hint: "https://www.bedbathandbeyond.com/…" },
  { key: "zola", label: "Zola", domain: "zola.com", hint: "https://www.zola.com/registry/…" },
  { key: "theknot", label: "The Knot", domain: "theknot.com", hint: "https://www.theknot.com/us/…/registry" },
  { key: "honeyfund", label: "Honeyfund", domain: "honeyfund.com", hint: "https://www.honeyfund.com/site/…" },
  { key: "blueprint", label: "Blueprint", domain: "blueprintregistry.com", hint: "https://blueprintregistry.com/registry/…" },
];

export function hostOf(url = "") {
  try { return new URL(/^https?:\/\//i.test(url) ? url : `https://${url}`).hostname.replace(/^www\./, ""); } catch { return ""; }
}

export function detectStore(url = "") {
  const h = hostOf(url);
  return STORES.find((s) => h === s.domain || h.endsWith(`.${s.domain}`)) || null;
}

export const logoFor = (url) => `https://www.google.com/s2/favicons?domain=${hostOf(url) || "example.com"}&sz=128`;

export const cashAppUrl = (tag = "") => `https://cash.app/$${tag.replace(/^\$/, "").trim()}`;

export const FUND_TYPES = ["cash_fund", "honeymoon_fund", "house_fund", "baby_fund"];

export const money = (n = 0) => { const v = Number(n) || 0; return Number.isInteger(v) ? v.toLocaleString() : v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
